const team = {
  "teachers": [
    {
      "id": "tieqiu",
      "name": "Tie Qiu",
      "image": "https://smartiot-lab.net/proxyApi/assets/qiutie.jpg",
      "introduction": "Doctor, a professor at the second level, doctoral supervisor, is a recipient of the National Science Fund for Distinguished Young Scholars and a Young Changjiang Scholar. He has won one first prize of the Tianjin Science and Technology Progress Award and two second prizes of the Dalian Science Works Award. He is a CCF Distinguished Member, an IEEE/ACM Senior Member, a standing committee member of the Network and Data Communication Special Committee, and a member of the Internet of Things Special Committee. He was a visiting scholar at the Department of Electrical and Computer Engineering at Iowa State University in the United States. His research mainly focuses on Internet of Things technology, intelligent perception, and industrial big data. Currently, he is an editorial board member of five SCI-indexed international journals including IEEE/ACM Transactions on Networking (ToN) and Elsevier Ad Hoc Networks. He has also served as a guest editor for multiple international academic journals. He has been the chairperson, program committee chairperson, and program committee member of several international conferences. He has authored and published 10 monographs and professional textbooks. He has obtained over 40 national invention patents and 5 computer software copyrights. He has published over 200 academic papers, some of which have been published in renowned international journals such as IEEE/ACM ToN, TMC, TKDE, JSAC, and at conferences such as IEEE INFOCOM, GLOBECOM, and ACM MobiHoc. Among them, 18 papers have been listed as ESI highly cited papers. He has led over 20 projects including national key research and development plans, key projects of the National Natural Science Foundation of China, and various other projects."
    },
    {
      "id": "xiaobozhou",
      "name": "Xiaobo Zhou",
      "image": "https://smartiotlab.net/proxyApi/assets/zhouxiaobo.jpg",
      "introduction": "Doctor, Professor and Ph.D. supervisor of the School of Intelligence and Computing, Tianjin University, with many years of research on key technologies of the Internet of Things and cloud computing, and a series of achievements. In recent years, he has published more than 100 high-quality papers in various international conferences and journals, including top journals and conferences in the field such as IEEE TMC, ACM/IEEE ToN, IEEE TPDS, IEEE TWC, IEEE COMST, INFOCOM, RTSS, IWQoS, ICDCS, and has been granted more than 10 national invention patents. He has undertaken 1 sub-project of the National Key Research and Development Program, 2 projects of the National Natural Science Foundation, 1 project of the Tianjin Natural Science Foundation, and 1 major special project of the Tianjin New Generation Artificial Intelligence. He has participated in multiple national natural science joint funds and national key research and development projects. He is a senior member of IEEE and CCF, a member of ACM, a member of the CCF Internet of Things Committee, and a member of the CCF Network and Data Communication Committee. He serves as an editorial board member of the SCI journal \"Frontiers in Computer Science\" and the international academic journal \"Computer Systems Science and Engineering Journal\". He has served as the chair/organizing chair of several internationally renowned conferences. He has won the Best Paper Award at international conferences four times and has been nominated for the Best Paper Award once. In 2018, he was selected as a participant in the Tianjin University \"Beiyang Scholars - Young Backbone Teachers Program\" and the third level of Tianjin's \"131\" innovative talent training project. In 2019, he won the Shen Zhikang Teaching Award at Tianjin University, and in 2020, he won the ACM China Rising Star Award (Tianjin). In 2021, he won the Tianjin Science and Technology Progress Special Award (ranked 9th)."
    },
    {
      "id": "dapengoliverwu",
      "name": "Dapeng Oliver Wu",
      "image": "https://smartiot-lab.net/proxyApi/assets/wudapeng.jpg",
      "introduction": "Dapeng Oliver Wu received the Ph.D. degree in electrical and computer engineering from Carnegie Mellon University, Pittsburgh, PA, in 2003. He is the Yeung Kin Man Chair Professor of network science, and the Chair Professor of data engineering at the Department of Computer Science, City University of Hong Kong. Previously, he was on the Faculty of the University of Florida, Gainesville, FL, USA, and the Director of the NSF Center for Big Learning, USA. His research interests are in the areas of artificial intelligence, network science, communications, signal processing, computer vision, and biomedical engineering.,Dr. Wu received the University of Florida Term Professorship Award in 2017, the University of Florida Research Foundation Professorship Award in 2009, the AFOSR Young Investigator Program (YIP) Award in 2009, the ONR Young Investigator Program (YIP) Award in 2008, the NSF CAREER Award in 2007, the IEEE Transactions on Emerging Topics in Computational Intelligence (TETCI) Outstanding Paper Award for Year 2025, the IEEE Transactions on Circuits and Systems for Video Technology (TCSVT) Best Paper Award for Year 2001, and the Best Paper Awards from IEEE GLOBECOM 2011 and International Conference on Quality of Service in Heterogeneous Wired/Wireless Networks (QShine) 2006. He has served as the Founding Editor in Chief for IEEE Transactions on Artificial Intelligence; the Editor in Chief for IEEE Transactions on Network Science and Engineering; the Founding Editor in Chief for Journal of Advances in Multimedia; the Editor-at-Large for IEEE Open Journal of the Communications Society; and an Associate Editor for IEEE Transactions on Cloud Computing, IEEE Transactions on Communications, IEEE Transactions on Signal and Information Processing over Networks, IEEE Signal Processing Magazine, TCSVT, IEEE Transactions on Wireless Communications, and IEEE Transactions on Vehicular Technology."
    },
    {
      "id": "weishengsi",
      "name": "Weisheng Si",
      "image": "https://smartiot-lab.net/proxyApi/assets/siweisheng.jpg",
      "introduction": "Weisheng Si received the B.S. degree in computer science from Peking University, Beijing, China, the M.S. degree in computer science from the University of Virginia, Charlottesville, VA, USA, and the Ph.D. degree in computer science from the University of Sydney, Sydney, NSW, Australia. He is currently a Senior Lecturer with the School of Computer, Data, and Mathematical Sciences, Western Sydney University, Sydney, NSW, Australia. Prior to this, he was a Postdoctoral Researcher with National ICT Australia. He has authored or coauthored dozens of papers in prestigious journals and conferences so far. His research interests mainly include network security, complex networks, and Internet of Things"
    },
    {
      "id": "songweizhang",
      "name": "Songwei Zhang",
      "image": "https://smartiot-lab.net/proxyApi/assets/zhangsongwei.jpg",
      "introduction": "Doctor, associate professor of computer science and engineering school of Northeastern University, master/doctoral supervisor, main research directions include industrial Internet of Things, network topology control, topology robustness optimization, artificial intelligence, quantum computing, etc., using quantum computing + machine learning new methods to solve the key problem of poor network robustness of massive devices brought about by the large-scale development of the Internet of Things.\\nHe has published 18 academic papers in top international SCI journals and conferences such as IEEE/ACM ToN (CCF-A), IEEE TMC (CCF-A), IEEE IoT Journal (CAS Zone 1), IEEE Wireless Communications (CAS Zone 1), IEEE Network, IEEE ICC, etc. (including 6 papers in CCF-A category and 2 papers in CAS/SCI Zone 1). He has applied for 6 invention patents and authorized 2 invention patents. He wrote the first academic monograph in the world to introduce the topological robustness of the Internet of Things, published by Springer.\nSince its publication, the number of online downloads has exceeded 43,000. As the backbone of the project, it has participated in 6 national/provincial and ministerial-level projects such as the project project/sub-project of the National Key R & D Program, the key project of the National Natural Science Foundation of China Joint Fund, the key project of the Ministry of Industry and Information Technology, the surface project of the National Natural Science Foundation of China, and the science and technology project of the State Grid Tianjin Electric Power Company. Build a comprehensive perception platform for the Industrial Internet of Things, which has passed the test of the China Industrial Internet Research Institute and obtained CNAS certification.\nHe has served as a reviewer for top international SCI journals such as IEEE/ACM ToN, IEEE TMC, IEEE IoT Journal, IEEE TNSE, IEEE Wireless Communications, and IEEE Network, as well as a reviewer for international conferences IEEE ICPADS 2022, ICC 2024, CSCWD 2024, CSCWD 2025, and chair of IEEE SmartIoT 2023."
    },
    {
      "id": "ningchen",
      "name": "Ning Chen",
      "image": "https://smartiot-lab.net/proxyApi/assets/chenning.jpg",
      "introduction": "Doctor, Assistant Researcher at City University of Hong Kong. Engaged in research on Internet of Things technology and intelligent big data analysis. Studied at the University of Amsterdam, Netherlands (University of Amsterdam) School of Informatics (2021-2022). Obtained 6 authorized national invention patents and 2 computer software copyrights. Has published more than 20 academic papers, including 9 CCF A-class/Core journals according to the Chinese Computer Federation (CCF) ranking and 2 ESI highly cited papers, including IEEE/ACM Transactions on Networking, Journal of Computer Science, IEEE COMST, IEEE WCM, IEEE COMMAG, IEEE IoT Journal, IEEE Network, Ad Hoc Network, JNCA, etc. Currently serving as a reviewer for international journals such as IEEE/ACM Transactions on Networking, IEEE Mobile Computing, and IEEE IoTJ, as well as a committee member of the SmartIoT International Conference and a PC member of conferences such as ICPADS, CSCWD, WASA, CIT, and IUCC. He has led Tianjin Municipal Graduate Research and Innovation Projects and participated in more than 10 projects including the National Natural Science Foundation Joint Key Project and the National Key R&D Program. He has received more than 20 honors, including the National Graduate Scholarship (twice), the National Study Abroad Scholarship (CSC), Tianjin Excellent Student, and Liaoning Outstanding Graduate."
    },
    {
      "id": "tianyixu",
      "name": "Tianyi Xu",
      "image": "https://smartiotlab.net/proxyApi/assets/xutianyi.jpg",
      "introduction": "Doctor, Senior Engineer at the School of Intelligence and Computing, Tianjin University, Master's supervisor, IEEE and CCF members, Executive Committee Member of the CCF Internet of Things Committee, and Executive Committee Member of the CCF Network and Data Communication Committee. Engaged in research on industrial Internet of Things, blockchain, natural language processing, data mining, and other related fields. In recent years, he has published more than 50 scientific and technological papers in various international journals and conferences such as IEEE TII, IEEE IoTJ, IEEE Globecom, and ECAI, and has obtained multiple authorized national invention patents and software copyrights. He has undertaken 1 sub-project of the National Natural Science Foundation Major Research Plan, 1 project of the Tianjin Natural Science Foundation, and participated in multiple national natural science foundation projects and key research and development projects. As a participant, he has won a first-class Tianjin Science and Technology Progress Award. He serves as a guiding teacher in the IT Discipline Innovation and Entrepreneurship Training Base, guiding students to participate in various high-level interdisciplinary competitions such as the National College Student Robot Competition RoboMaster, the National College Student Intelligent Vehicle Competition, and the China Robot and Artificial Intelligence Competition, and has won more than 60 national and provincial awards. As a participant, he has won one second prize of the National Teaching Achievement Award, two second prizes of the Tianjin Municipal Teaching Achievement Award, and one first prize of the Tianjin University Teaching Achievement Award. He was awarded the Shen Zhikang Teaching Award at Tianjin University in 2019."
    },
    {
      "id": "bingxianlu",
      "name": "Bingxian Lu",
      "image": "https://smartiot-lab.net/proxyApi/assets/lubingxian.jpg",
      "introduction": "Doctor, an associate professor at the School of Computer Science and Engineering, Northeastern University, is a master's and doctoral supervisor. His main research areas include novel perception and computing, wireless location security, and industrial large models. He integrates new methods such as intelligent perception and wireless positioning to enhance the security and usability of wireless networks. His research has been published in renowned international journals and top conferences such as ACM SIGCOMM (CCF A) and IEEE INFOCOM (CCF A). As the first or corresponding author, he has published over 20 high-level papers and obtained 12 invention patents. He has led one National Natural Science Foundation of China Youth Project, one major project of Liaoning Province's Science and Technology Innovation, and one key research and development project of Dalian City. He has also participated in two key projects of the National Natural Science Foundation of China. His research achievements have won the Second Prize of Liaoning Province Science and Technology Progress Award and the 2021 ACM Rising Star Award. He has been selected as a member of the Communication Committee of the Internet of Things Youth Professional Technical Group of the Chinese Institute of Electronics and serves as a guest editor for SCI journals such as WCMC and a technical committee member (TPC) for international conferences like WASA (CCF C)."
    },
    {
      "id": "haizhao",
      "name": "Hai Zhao",
      "image": "https://smartiot-lab.net/proxyApi/assets/zhaohai.jpg",
      "introduction": "Professor of the Institute of Computer Systems, Doctoral Supervisor, Director of the Embedded Technology Laboratory, Member of the Liaoning Provincial Committee of the Chinese People's Political Consultative Conference, and Vice Chairman of the Liaoning Provincial Committee of the China Democratic League. Currently, he is a professor and doctoral supervisor at the School of Computer Science and Engineering, Northeastern University (with a special government allowance from the State Council), and the director of the Embedded Technology Laboratory. He has led and completed multiple national-level projects and programs, including the National 863 Program, the National Natural Science Foundation, the National Torch Program, the National Innovation Fund for Small and Medium-sized Technology-based Enterprises, and the High-tech Industrialization Demonstration Project of the National Development and Reform Commission. He participated in the compilation of the national standard and the Ministry of Machinery and Electronics Industry standard for \"Factory Automation Protocol MAP 3.0\". He has authored several academic monographs such as \"Embedded Internet\", \"Bluetooth Technology Application\", \"Broadband Technology Specifications and Applications for Factory Automation\", and \"Fieldbus Technology and Prospects\", and has won six provincial and ministerial-level science and technology awards. He has applied for ten national patents and software copyrights, and has published over 200 related academic papers. He founded Shenyang Dongda Xinye Information Technology Co., Ltd., established the first node of the international Internet Data Analysis Joint Organization (CAIDA) in China, and has maintained long-term research and teaching cooperation with universities such as the University of Waterloo in Canada, UTD and UTA in the United States."
    }
  ],
  "docters": [
    {
      "year": "2021",
      "id": "105",
      "image": "https://smartiotlab.net/proxyApi/assets/zhaoyingying.jpg",
      "name": "Yingying Zhao",
      "EnName": "Yingying Zhao",
      "researchs": "Wireless Sensing and Behavior Recognition",
      "Enresearchs": "Wireless Sensing and Behavior Recognition"
    },
    {
      "year": "2022",
      "id": "107",
      "image": "https://smartiotlab.net/proxyApi/assets/Adii.jpg",
      "name": "Adil Muhammad",
      "EnName": "Adil Muhammad",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2022",
      "id": "106",
      "image": "https://smartiotlab.net/proxyApi/assets/wangweixu.jpg",
      "name": "Weixu Wang",
      "EnName": "Weixu Wang",
      "researchs": "Time Series Anomaly Detection",
      "Enresearchs": "Time Series Anomaly Detection"
    },
    {
      "year": "2023",
      "id": "108",
      "image": "https://smartiotlab.net/proxyApi/assets/caozhenrui.jpg",
      "name": "Zhenrui Cao",
      "EnName": "Zhenrui Cao",
      "researchs": "Industrial Network Transmission",
      "Enresearchs": "Industrial Network Transmission"
    },
    {
      "year": "2024",
      "id": "109",
      "image": "https://smartiotlab.net/proxyApi/assets/limengzhen.png",
      "name": "Mengzhen Li",
      "EnName": "Mengzhen Li",
      "researchs": "Multimodal Collaboration Perception",
      "Enresearchs": "Multimodal Collaboration Perception"
    },
    {
      "year": "2024",
      "id": "110",
      "image": "https://smartiotlab.net/proxyApi/assets/liushuang.jpg",
      "name": "Shuang Liu",
      "EnName": "Shuang Liu",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2024",
      "id": "111",
      "image": "https://smartiotlab.net/proxyApi/assets/%E6%9D%8E%E7%A1%95-%E5%B7%A5%E4%B8%9A%E6%95%B0%E5%AD%97%E5%AD%AA%E7%94%9F.jpg",
      "name": "Shuo Li",
      "EnName": "Shuo Li",
      "researchs": "Industrial Digital Twin",
      "Enresearchs": "Industrial Digital Twin"
    },
    {
      "year": "2024",
      "id": "1",
      "image": "https://smartiot-lab.net/proxyApi/assets/jiayifei.jpg",
      "name": "Yifei Jia",
      "EnName": "Yifei Jia",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2025",
      "id": "2",
      "image": "https://smartiot-lab.net/proxyApi/assets/yubaofeng.jpg",
      "name": "Baofeng Yu",
      "EnName": "Baofeng Yu",
      "researchs": "Industrial Fault Diagnosis",
      "Enresearchs": "Industrial Fault Diagnosis"
    },
    {
      "year": "2025",
      "id": "113",
      "image": "https://smartiotlab.net/proxyApi/assets/caosong.jpg",
      "name": "Song Cao",
      "EnName": "Song Cao",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2025",
      "id": "114",
      "image": "https://smartiotlab.net/proxyApi/assets/yuantingli.jpg",
      "name": "Tingli Yuan",
      "EnName": "Tingli Yuan",
      "researchs": "Computer network resource management and scheduling",
      "Enresearchs": "Computer network resource management and scheduling"
    },
    {
      "year": "2025",
      "id": "3",
      "image": "https://smartiot-lab.net/proxyApi/assets/lvxumeng.jpg",
      "name": "Xumeng Lv",
      "EnName": "Xumeng Lv",
      "researchs": "Industrial Multimodal Perception",
      "Enresearchs": "Industrial Multimodal Perception"
    },
    {
      "year": "2025",
      "id": "112",
      "image": "https://smartiotlab.net/proxyApi/assets/niuziyu.jpg",
      "name": "Ziyu Niu",
      "EnName": "Ziyu Niu",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    }
  ],
  "masters": [
    {
      "year": "2023",
      "id": "240",
      "image": "https://smartiotlab.net/proxyApi/assets/zhangaiting.png",
      "name": "Aiting Zhang",
      "EnName": "Aiting Zhang",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2023",
      "id": "234",
      "image": "https://smartiotlab.net/proxyApi/assets/suhao.jpg",
      "name": "Hao Su",
      "EnName": "Hao Su",
      "researchs": "Industrial Network Transmission",
      "Enresearchs": "Industrial Network Transmission"
    },
    {
      "year": "2023",
      "id": "232",
      "image": "https://smartiotlab.net/proxyApi/assets/lijiqiao.jpg",
      "name": "Jiqiao Li",
      "EnName": "Jiqiao Li",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2023",
      "id": "237",
      "image": "https://smartiotlab.net/proxyApi/assets/yanglihua.jpg",
      "name": "Lihua Yang",
      "EnName": "Lihua Yang",
      "researchs": "Time Series Anomaly Detection",
      "Enresearchs": "Time Series Anomaly Detection"
    },
    {
      "year": "2023",
      "id": "238",
      "image": "https://smartiotlab.net/proxyApi/assets/hongtianyu.jpg",
      "name": "Tianyu Hong",
      "EnName": "Tianyu Hong",
      "researchs": "Vehicle Cooperative Perception",
      "Enresearchs": "Vehicle Cooperative Perception"
    },
    {
      "year": "2023",
      "id": "233",
      "image": "https://smartiotlab.net/proxyApi/assets/huangxiaochen.png",
      "name": "Xiaochen Huang",
      "EnName": "Xiaochen Huang",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2023",
      "id": "236",
      "image": "https://smartiotlab.net/proxyApi/assets/xuzhiqiang.jpg",
      "name": "Zhiqiang Xu",
      "EnName": "Zhiqiang Xu",
      "researchs": "Industrial Network Transmission",
      "Enresearchs": "Industrial Network Transmission"
    },
    {
      "year": "2023",
      "id": "239",
      "image": "https://smartiotlab.net/proxyApi/assets/pangzhizhuo.jpg",
      "name": "Zhizhuo Pang",
      "EnName": "Zhizhuo Pang",
      "researchs": "3D Scene Reconstruction",
      "Enresearchs": "3D Scene Reconstruction"
    },
    {
      "year": "2023",
      "id": "235",
      "image": "https://smartiotlab.net/proxyApi/assets/ganziqi.jpg",
      "name": "Ziqi Gan",
      "EnName": "Ziqi Gan",
      "researchs": "Industrial Blockchain",
      "Enresearchs": "Industrial Blockchain"
    },
    {
      "year": "2024",
      "id": "255",
      "image": "https://smartiotlab.net/proxyApi/assets/yangboyu.jpg",
      "name": "Boyu Yang",
      "EnName": "Boyu Yang",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2024",
      "id": "257",
      "image": "https://smartiotlab.net/proxyApi/assets/%E4%B8%81%E6%B5%A9-%E5%B7%A5%E4%B8%9A%E8%AE%BE%E5%A4%87%E7%BB%84%E7%BD%91%E4%BC%98%E5%8C%96.jpg",
      "name": "Hao Ding",
      "EnName": "Hao Ding",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2024",
      "id": "260",
      "image": "https://smartiotlab.net/proxyApi/assets/%E7%94%B3%E6%B5%A9%E6%A5%A0-%E5%B7%A5%E4%B8%9A%E6%95%B0%E5%AD%97%E5%AD%AA%E7%94%9F.jpg",
      "name": "Haonan Shen",
      "EnName": "Haonan Shen",
      "researchs": "Industrial Digital Twin",
      "Enresearchs": "Industrial Digital Twin"
    },
    {
      "year": "2024",
      "id": "251",
      "image": "https://smartiotlab.net/proxyApi/assets/bojianghao.jpg",
      "name": "Jianghao Bo",
      "EnName": "Jianghao Bo",
      "researchs": "Industrial Network Transmission",
      "Enresearchs": "Industrial Network Transmission"
    },
    {
      "year": "2024",
      "id": "263",
      "image": "https://smartiotlab.net/proxyApi/assets/%E4%BA%8E%E5%AE%B6%E4%BC%9F-%E6%97%B6%E5%BA%8F%E5%BC%82%E5%B8%B8%E6%A3%80%E6%B5%8B.jpg",
      "name": "Jiawei Yu",
      "EnName": "Jiawei Yu",
      "researchs": "Computer network resource management and scheduling",
      "Enresearchs": "Computer network resource management and scheduling"
    },
    {
      "year": "2024",
      "id": "259",
      "image": "https://smartiotlab.net/proxyApi/assets/%E9%BB%84%E6%99%AF%E5%8B%83-%E5%B7%A5%E4%B8%9A%E6%95%B0%E5%AD%97%E5%AD%AA%E7%94%9F.jpg",
      "name": "Jinbo Huang",
      "EnName": "Jinbo Huang",
      "researchs": "Industrial Digital Twin",
      "Enresearchs": "Industrial Digital Twin"
    },
    {
      "year": "2024",
      "id": "253",
      "image": "https://smartiotlab.net/proxyApi/assets/shanglei.jpg",
      "name": "Lei Shang",
      "EnName": "Lei Shang",
      "researchs": "Industrial Blockchain",
      "Enresearchs": "Industrial Blockchain"
    },
    {
      "year": "2024",
      "id": "261",
      "image": "https://smartiotlab.net/proxyApi/assets/%E7%8E%8B%E5%85%A8%E7%91%9E-%E8%BD%A6%E8%BE%86%E5%8D%8F%E4%BD%9C%E6%84%9F%E7%9F%A5.jpg",
      "name": "Quanrui Wang",
      "EnName": "Quanrui Wang",
      "researchs": "Computer network resource management and scheduling",
      "Enresearchs": "Computer network resource management and scheduling"
    },
    {
      "year": "2024",
      "id": "254",
      "image": "https://smartiotlab.net/proxyApi/assets/chaishuowen.jpg",
      "name": "Shuowen Chai",
      "EnName": "Shuowen Chai",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2024",
      "id": "252",
      "image": "https://smartiotlab.net/proxyApi/assets/sichengming.jpg",
      "name": "Sicheng Ming",
      "EnName": "Sicheng Ming",
      "researchs": "Industrial Network Transmission",
      "Enresearchs": "Industrial Network Transmission"
    },
    {
      "year": "2024",
      "id": "258",
      "image": "https://smartiotlab.net/proxyApi/assets/%E5%86%AF%E6%82%A6%E5%AE%A0-%E5%B7%A5%E4%B8%9A%E5%A4%A7%E6%95%B0%E6%8D%AE%E5%88%86%E6%9E%90.jpg",
      "name": "Yuechong Feng",
      "EnName": "Yuechong Feng",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2024",
      "id": "262",
      "image": "https://smartiotlab.net/proxyApi/assets/%E5%BE%90%E5%8D%93-3D%E5%9C%BA%E6%99%AF%E9%87%8D%E5%BB%BA.jpg",
      "name": "Zhuo Xu",
      "EnName": "Zhuo Xu",
      "researchs": "3D Scene Reconstruction",
      "Enresearchs": "3D Scene Reconstruction"
    },
    {
      "year": "2024",
      "id": "256",
      "image": "https://smartiotlab.net/proxyApi/assets/%E6%9B%BE%E6%A2%93%E7%90%A6-%E5%B7%A5%E4%B8%9A%E7%BD%91%E7%BB%9C%E4%BC%A0%E8%BE%93.jpg",
      "name": "Ziqi Zeng",
      "EnName": "Ziqi Zeng",
      "researchs": "Industrial Network Transmission",
      "Enresearchs": "Industrial Network Transmission"
    },
    {
      "year": "2025",
      "id": "281",
      "image": "https://smartiotlab.net/proxyApi/assets/huancheng.jpg",
      "name": "Cheng Huan",
      "EnName": "Cheng Huan",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2025",
      "id": "279",
      "image": "https://smartiotlab.net/proxyApi/assets/niucongcong.jpg",
      "name": "Congcong Niu",
      "EnName": "Congcong Niu",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2025",
      "id": "11",
      "image": "https://smartiot-lab.net/proxyApi/assets/wangfengchao.jpg",
      "name": "Fengchao Wang",
      "EnName": "Fengchao Wang",
      "researchs": "Industrial Multimodal Perception",
      "Enresearchs": "Industrial Multimodal Perception"
    },
    {
      "year": "2025",
      "id": "267",
      "image": "https://smartiotlab.net/proxyApi/assets/guoguangzheng.jpg",
      "name": "Guangzheng Guo",
      "EnName": "Guangzheng Guo",
      "researchs": "Industrial Internet of Things",
      "Enresearchs": "Industrial Internet of Things"
    },
    {
      "year": "2025",
      "id": "15",
      "image": "https://smartiot-lab.net/proxyApi/assets/jianhao.jpg",
      "name": "Hao Jian",
      "EnName": "Hao Jian",
      "researchs": "Research Topic",
      "Enresearchs": "Research Topic"
    },
    {
      "year": "2025",
      "id": "268",
      "image": "https://smartiotlab.net/proxyApi/assets/zhangjing.jpg",
      "name": "Jing Zhang",
      "EnName": "Jing Zhang",
      "researchs": "Collaborative Perception",
      "Enresearchs": "Collaborative Perception"
    },
    {
      "year": "2025",
      "id": "20",
      "image": "https://smartiot-lab.net/proxyApi/assets/zhangqinyang.jpg",
      "name": "Qinyang Zhang",
      "EnName": "Qinyang Zhang",
      "researchs": "Research Topic",
      "Enresearchs": "Research Topic"
    },
    {
      "year": "2025",
      "id": "9",
      "image": "https://smartiot-lab.net/proxyApi/assets/liuqizhou.jpg",
      "name": "Qizhou Liu",
      "EnName": "Qizhou Liu",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2025",
      "id": "264",
      "image": "https://smartiotlab.net/proxyApi/assets/caoruimeng.jpg",
      "name": "Ruimeng Cao",
      "EnName": "Ruimeng Cao",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2025",
      "id": "274",
      "image": "https://smartiotlab.net/proxyApi/assets/hansichen.jpg",
      "name": "Sichen Han",
      "EnName": "Sichen Han",
      "researchs": "Industrial Digital Twin",
      "Enresearchs": "Industrial Digital Twin"
    },
    {
      "year": "2025",
      "id": "275",
      "image": "https://smartiotlab.net/proxyApi/assets/yintao.jpg",
      "name": "Tao Yin",
      "EnName": "Tao Yin",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2025",
      "id": "265",
      "image": "https://smartiotlab.net/proxyApi/assets/futianci.jpg",
      "name": "Tianci Fu",
      "EnName": "Tianci Fu",
      "researchs": "Multi-vehicle cooperative perception",
      "Enresearchs": "Multi-vehicle cooperative perception"
    },
    {
      "year": "2025",
      "id": "13",
      "image": "https://smartiot-lab.net/proxyApi/assets/chenweijie.jpg",
      "name": "Weijie Chen",
      "EnName": "Weijie Chen",
      "researchs": "Research Topic",
      "Enresearchs": "Research Topic"
    },
    {
      "year": "2025",
      "id": "17",
      "image": "https://smartiot-lab.net/proxyApi/assets/xuweijie.jpg",
      "name": "Weijie Xu",
      "EnName": "Weijie Xu",
      "researchs": "Research Topic",
      "Enresearchs": "Research Topic"
    },
    {
      "year": "2025",
      "id": "282",
      "image": "https://smartiotlab.net/proxyApi/assets/jingwenshan.jpg",
      "name": "Wenshan Jing",
      "EnName": "Wenshan Jing",
      "researchs": "Industrial Network Transmission",
      "Enresearchs": "Industrial Network Transmission"
    },
    {
      "year": "2025",
      "id": "4",
      "image": "https://smartiot-lab.net/proxyApi/assets/xiaxinfu.jpg",
      "name": "Xinfu Xia",
      "EnName": "Xinfu Xia",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2025",
      "id": "269",
      "image": "https://smartiotlab.net/proxyApi/assets/luoxiwen.jpg",
      "name": "Xiwen Luo",
      "EnName": "Xiwen Luo",
      "researchs": "Anomaly Detection",
      "Enresearchs": "Anomaly Detection"
    },
    {
      "year": "2025",
      "id": "273",
      "image": "https://smartiotlab.net/proxyApi/assets/liuyang.jpg",
      "name": "Yang Liu",
      "EnName": "Yang Liu",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2025",
      "id": "271",
      "image": "https://smartiotlab.net/proxyApi/assets/xueyawen.jpg",
      "name": "Yawen Xue",
      "EnName": "Yawen Xue",
      "researchs": "Computer network resource management and scheduling",
      "Enresearchs": "Computer network resource management and scheduling"
    },
    {
      "year": "2025",
      "id": "276",
      "image": "https://smartiotlab.net/proxyApi/assets/wangyike.jpg",
      "name": "Yike Wang",
      "EnName": "Yike Wang",
      "researchs": "Collaborative Perception",
      "Enresearchs": "Collaborative Perception"
    },
    {
      "year": "2025",
      "id": "266",
      "image": "https://smartiotlab.net/proxyApi/assets/wangyingwenbo.jpg",
      "name": "Yingwenbo Wang",
      "EnName": "Yingwenbo Wang",
      "researchs": "Industrial Agreement Analysis",
      "Enresearchs": "Industrial Agreement Analysis"
    },
    {
      "year": "2025",
      "id": "19",
      "image": "https://smartiot-lab.net/proxyApi/assets/yuanyuan.jpg",
      "name": "Yuan Yuan",
      "EnName": "Yuan Yuan",
      "researchs": "Research Topic",
      "Enresearchs": "Research Topic"
    },
    {
      "year": "2025",
      "id": "10",
      "image": "https://smartiot-lab.net/proxyApi/assets/jiyuheng.jpg",
      "name": "Yuheng Ji",
      "EnName": "Yuheng Ji",
      "researchs": "Industrial Fault Diagnosis",
      "Enresearchs": "Industrial Fault Diagnosis"
    },
    {
      "year": "2025",
      "id": "14",
      "image": "https://smartiot-lab.net/proxyApi/assets/huangyulu.jpg",
      "name": "Yulu Huang",
      "EnName": "Yulu Huang",
      "researchs": "Research Topic",
      "Enresearchs": "Research Topic"
    },
    {
      "year": "2025",
      "id": "8",
      "image": "https://smartiot-lab.net/proxyApi/assets/hanyunfu.jpg",
      "name": "Yunfu Han",
      "EnName": "Yunfu Han",
      "researchs": "Industrial Digital Twin",
      "Enresearchs": "Industrial Digital Twin"
    },
    {
      "year": "2025",
      "id": "278",
      "image": "https://smartiotlab.net/proxyApi/assets/liuyuxuan.jpg",
      "name": "Yuxuan Liu",
      "EnName": "Yuxuan Liu",
      "researchs": "Industrial Digital Twin",
      "Enresearchs": "Industrial Digital Twin"
    },
    {
      "year": "2025",
      "id": "270",
      "image": "https://smartiotlab.net/proxyApi/assets/mazeyu.jpg",
      "name": "Zeyu Ma",
      "EnName": "Zeyu Ma",
      "researchs": "Computer network resource management and scheduling",
      "Enresearchs": "Computer network resource management and scheduling"
    },
    {
      "year": "2025",
      "id": "280",
      "image": "https://smartiotlab.net/proxyApi/assets/shuzhen.jpg",
      "name": "Zhen Shu",
      "EnName": "Zhen Shu",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2025",
      "id": "277",
      "image": "https://smartiotlab.net/proxyApi/assets/chenzhengyu.jpg",
      "name": "Zhengyu Chen",
      "EnName": "Zhengyu Chen",
      "researchs": "Anomaly Detection",
      "Enresearchs": "Anomaly Detection"
    },
    {
      "year": "2025",
      "id": "18",
      "image": "https://smartiot-lab.net/proxyApi/assets/yangzhiwei.jpg",
      "name": "Zhiwei Yang",
      "EnName": "Zhiwei Yang",
      "researchs": "Research Topic",
      "Enresearchs": "Research Topic"
    },
    {
      "year": "2025",
      "id": "272",
      "image": "https://smartiotlab.net/proxyApi/assets/liuzikang.jpg",
      "name": "Zikang Liu",
      "EnName": "Zikang Liu",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    }
  ],
  "undergraduates": [
    {
      "year": "2022",
      "id": "12",
      "image": "https://smartiot-lab.net/proxyApi/assets/luxiyu.jpg",
      "name": "Xiyu Lu",
      "EnName": "Xiyu Lu",
      "researchs": "Industrial Scenario Simulation",
      "Enresearchs": "Industrial Scenario Simulation"
    },
    {
      "year": "2023",
      "id": "16",
      "image": "https://smartiot-lab.net/proxyApi/assets/xuchaowen.jpg",
      "name": "Chaowen Xu",
      "EnName": "Chaowen Xu",
      "researchs": "Research Topic",
      "Enresearchs": "Research Topic"
    }
  ],
  "graduates": [
    {
      "year": "1",
      "id": "4002",
      "image": "",
      "name": "闾远",
      "EnName": "闾远",
      "researchs": "Postal Savings Bank of China",
      "Enresearchs": "Postal Savings Bank of China"
    },
    {
      "year": "2018",
      "id": "3997",
      "image": "https://smartiotlab.net/proxyApi/assets/zengjiaxin.jpg",
      "name": "Jiaxin Zeng",
      "EnName": "Jiaxin Zeng",
      "researchs": "Edge Caching Strategy Research",
      "Enresearchs": "Edge Caching Strategy Research"
    },
    {
      "year": "2020",
      "id": "4000",
      "image": "https://smartiotlab.net/proxyApi/assets/chijiancheng.jpg",
      "name": "Jiancheng Chi",
      "EnName": "Jiancheng Chi",
      "researchs": "Industrial Big Data Analysis",
      "Enresearchs": "Industrial Big Data Analysis"
    },
    {
      "year": "2020",
      "id": "3998",
      "image": "https://smartiotlab.net/proxyApi/assets/geshuxin.jpg",
      "name": "Shuxin Ge",
      "EnName": "Shuxin Ge",
      "researchs": "Vehicle Ride-sharing Dispatch",
      "Enresearchs": "Vehicle Ride-sharing Dispatch"
    },
    {
      "year": "2021",
      "id": "3999",
      "image": "https://smartiotlab.net/proxyApi/assets/zhangsongwei.jpg",
      "name": "Songwei Zhang",
      "EnName": "Songwei Zhang",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2022",
      "id": "4036",
      "image": "https://smartiotlab.net/proxyApi/assets/wangchuanan.jpg",
      "name": "Chuan'an Wang",
      "EnName": "Chuan'an Wang",
      "researchs": "Vehicle Cooperative Perception",
      "Enresearchs": "Vehicle Cooperative Perception"
    },
    {
      "year": "2022",
      "id": "4037",
      "image": "https://smartiotlab.net/proxyApi/assets/jiangdadong.jpg",
      "name": "Dadong Jiang",
      "EnName": "Dadong Jiang",
      "researchs": "3D Scene Reconstruction",
      "Enresearchs": "3D Scene Reconstruction"
    },
    {
      "year": "2022",
      "id": "4035",
      "image": "https://smartiotlab.net/proxyApi/assets/yanhao.jpg",
      "name": "Hao Yan",
      "EnName": "Hao Yan",
      "researchs": "3D Scene Reconstruction",
      "Enresearchs": "3D Scene Reconstruction"
    },
    {
      "year": "2022",
      "id": "4032",
      "image": "https://smartiotlab.net/proxyApi/assets/sunjingchen.jpg",
      "name": "Jingchen Sun",
      "EnName": "Jingchen Sun",
      "researchs": "Industrial Network Optimization",
      "Enresearchs": "Industrial Network Optimization"
    },
    {
      "year": "2022",
      "id": "4033",
      "image": "https://smartiotlab.net/proxyApi/assets/renlinjie.png",
      "name": "Linjie Ren",
      "EnName": "Linjie Ren",
      "researchs": "Industrial Blockchain",
      "Enresearchs": "Industrial Blockchain"
    },
    {
      "year": "2022",
      "id": "4034",
      "image": "https://smartiotlab.net/proxyApi/assets/liuzhaoda.jpg",
      "name": "Zhaoda Liu",
      "EnName": "Zhaoda Liu",
      "researchs": "Wireless Sensing and Behavior Recognition",
      "Enresearchs": "Wireless Sensing and Behavior Recognition"
    }
  ]
};

export default team;
